import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '~/components/Modal/Modal';
import { useModal } from '~/hooks/useModal';
import DeliveryInstructions from '~/pages/Checkout/components/DeliveryInstructions/DeliveryInstructions';
import Textarea from '~/pages/Checkout/components/Textarea/Textarea';

import { checkoutStore } from '~/stores';

import { ModalBody, ModalFooter, ModalHeader } from '../ModalComponents';

import styles from './ModalComment.module.scss';

const ModalComment = () => {
  const [comment, setComment] = useState(checkoutStore.commentVal || '');
  const { t } = useTranslation();
  const { closeModal } = useModal();

  const handleCommentChange = (val: string) => {
    setComment(val);
  };

  const handleSaveComment = () => {
    checkoutStore.setCommentVal(comment);
  };

  return (
    <Modal
      isShow={true}
      className={styles.comment}
      onBackdropDismiss={() => closeModal()}
    >
      <div className={styles.comment__container}>
        <ModalHeader title={t('checkout:comment')} onClose={closeModal} />
        <ModalBody className={styles.comment__body}>
          <Textarea
            placeholder={t('checkout:yourComment')}
            onChange={handleCommentChange}
            value={comment}
          />
          <DeliveryInstructions classNames={styles.instructions} />
        </ModalBody>
        <ModalFooter className={styles.comment__footer}>
          <button
            data-button="comment"
            className="button _primary _med"
            onClick={handleSaveComment}
          >
            {t('save')}
          </button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default ModalComment;
